// extracted by mini-css-extract-plugin
export default {"fullWidth":"Uk-z","image":"Vk-z","lazyLoadPicture":"Wk-z","lazyLoadSpinner":"Xk-z","lazyLoadSpin":"Yk-z","lazyLoadImage":"Zk-z","hasStyledAspectRatio":"_k-z"};